module.exports = __webpack_public_path__ + "static/alcacuz-inverno-2019-730f2b56b0f25eee6e386e613b2c6b47.jpg";